import ButtonCommon from 'components/common/ButtonCommon';
import {
  DESKTOP_MIN_WIDTH,
  FUNC_DEFAULT,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import useLang from 'hooks/useLang';
import { isEmpty } from 'lodash';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

const CancelNavigatingAwayFromFlowPopup = ({
  isOpen,
  imageSrc,
  imagesStyles = {},
  alignContent = 'left' || 'center' || 'right',
  onClose,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
  modalStyles = {},
}) => {
  const { t } = useLang();
  const { subTextStyles } = modalStyles || {};

  const { isMakePayment } = useFormAddTransactionStore();

  const renderImageSrc = () => {
    if (isMakePayment) return null;
    return (
      <>
        {imageSrc && (
          <ImageWrap>
            <img
              src={imageSrc}
              alt=""
              width={50}
              height={50}
              style={imagesStyles}
            />
          </ImageWrap>
        )}
      </>
    );
  };

  const renderTitleMessage = () => {
    const title = isMakePayment ? '' : t('popup_cancel_add_transaction');

    if (isEmpty(title)) return null;
    return <Text dangerouslySetInnerHTML={{ __html: title }} />;
  };

  const renderContentMessage = () => {
    const content = isMakePayment
      ? t('popup_confirm_back_transaction')
      : t('popup_cancel_add_transaction_desc');

    if (isEmpty(content)) return null;
    return (
      <SubText
        $alignContent={alignContent}
        dangerouslySetInnerHTML={{ __html: content }}
        style={subTextStyles}
      />
    );
  };

  return (
    <>
      <style>
        {zIndexModal
          ? `
          @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
            .modal {
              z-index: ${zIndexModal || 1101};
            }
          }
        `
          : ``}

        {isBackdropOverlap
          ? `
          .cancel-navigating-away-flow-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || 1100}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .cancel-navigating-away-flow-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={FUNC_DEFAULT}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="cancel-navigating-away-flow-modal-backdrop"
        centered
      >
        <ModalBody>
          {renderImageSrc()}
          {renderTitleMessage()}
          {renderContentMessage()}
        </ModalBody>
        <ModalFooter>
          <ButtonCommon
            value={t('button_no')}
            onClick={onClose}
            styles={{
              margin: '0px',
              width: '50%',
            }}
            color="var(--ds-c-blue)"
            background="var(--ds-c-white)"
          />
          <ButtonCommon
            value={t('button_yes')}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
            styles={{
              margin: '0px',
              width: '50%',
            }}
            onClick={onClick}
            isUseKeyDown
          />
        </ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  padding-left: 0px !important;
  padding-right: 0px !important;

  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 16px;
      border-radius: 8px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      height: fit-content;
      margin-inline: auto;
      border: none;
    }
  }

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    & .modal-dialog {
      margin-inline: 16px;
      transform: none;
      & .modal-content {
        width: 100%;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        width: 343px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  margin-bottom: 24px;
  text-align: left;
`;
const ImageWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const Text = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  color: var(--ds-c-blue);
  margin: 0;
  margin-bottom: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const SubText = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: ${(props) => props.$alignContent};
  white-space: break-spaces;

  color: var(--ds-c-grey-dark);
  margin: 0;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  & b {
    color: var(--ds-c-blue-hyperlink-default);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

export default CancelNavigatingAwayFromFlowPopup;
